import adminApiClient from '../../api/base/adminApiClient'

/** 가입 직후 추천 피드에 고정으로 보일 기록 한 줄 */
export interface CuratedFeedItem {
  /** 목록 행의 id (기록 id와 다르다 — 순서 변경·삭제에 쓴다) */
  id: number
  review_id: number
  position: number
  /**
   * 기록이 아직 살아 있는지.
   *
   * 지워졌거나 비공개로 바뀌면 화면에 보여줄 수 없다. 목록에서 자동으로 빼지
   * 않고 표시만 해준다 — 관리자가 보고 판단하게 한다.
   */
  exists: boolean
  place_name: string | null
  username: string | null
  score: number | null
  review_text: string | null
  is_public: boolean | null
}

export const adminCuratedFeedApi = {
  list: async (): Promise<{ data: CuratedFeedItem[] }> => {
    const response =
      await adminApiClient.get<{ data: CuratedFeedItem[] }>('/admin/curated-feed')
    return response.data
  },
  add: async (reviewId: number): Promise<{ message: string }> => {
    const response = await adminApiClient.post<{ message: string }>(
      '/admin/curated-feed',
      { review_id: reviewId }
    )
    return response.data
  },
  remove: async (id: number): Promise<{ message: string }> => {
    const response = await adminApiClient.delete<{ message: string }>(
      `/admin/curated-feed/${id}`
    )
    return response.data
  },
  /** 화면에 보이는 순서 그대로 id 배열을 보낸다 */
  reorder: async (ids: number[]): Promise<{ message: string }> => {
    const response = await adminApiClient.put<{ message: string }>(
      '/admin/curated-feed/order',
      { ids }
    )
    return response.data
  },
}
